import React from 'react';

import Lottie from 'react-lottie';
import PropTypes from 'prop-types';

import loadingData from './loading.json';
import { Wrapper } from './Loading.styles';

const Loading = (props) => {
  // PROPS
  const { relative, absolute } = props;
  // PROPS

  //DEFS
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  //DEFS

  return (
    <Wrapper relative={relative} absolute={absolute}>
      <div>
        <Lottie options={defaultOptions} />
      </div>
    </Wrapper>
  );
};

Loading.propTypes = {
  relative: PropTypes.bool,
  absolute: PropTypes.bool,
};

export default Loading;
